import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { submitForm } from 'store/api/submitForm/submitForm';
import { ChangePasswordResponse, ValidateTokenResponse } from 'store/api/types';
import { changePassword, validateToken } from 'store/api/user/userActions';

import { ChangePassword } from './ChangePassword';
import { ChangePasswordProps } from './ChangePassword.types';

const mapDispatchToProps = (
  dispatch: Dispatch,
  {
    match: {
      params: { token },
    },
  }: ChangePasswordProps,
) => ({
  onChangePassword: submitForm<ChangePasswordResponse>(dispatch, changePassword),
  onValidateToken: () => dispatch<Promise<ValidateTokenResponse>>(validateToken(token)),
});

export const ChangePasswordContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(ChangePassword);
